export default "__VITE_ASSET__DNvkKUB0__"